import { gql } from '@apollo/client'

export const MUTATION_CANCEL_DEVICE = gql`
  mutation mutationCancelDevice($input: CancelDeviceCaseItemInput) {
    createCancelDeviceCaseItem(input: $input) {
      id
    }
  }
`
